import React, {Component, ReactElement} from 'react'
import NatStepComponent, {DIspStepInfo, Step} from '../common/resident/NatStepComponent'
import {ContentsSubTitleInner, ContentsSubTitleWrapper, WideMainContainer} from '../../../styledComponents/ContentsArea'
import {PrimaryStyledButton} from '../../../styledComponents/Button'
import {StyledP} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {Box} from '@mui/material'
import {Location} from 'react-router-dom'

interface Props {
    location: Location
}

interface States {
    dIspStepInfo: DIspStepInfo
}

class NatResidentPasswordResetCompletePage extends Component<Props & ResidentPagePropsSet, States> {

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            dIspStepInfo: {reSetting: true, complete: true},
        }

        this.linkLoginButtonClick = this.linkLoginButtonClick.bind(this)
    }

    // ログインする
    linkLoginButtonClick(): void {
        this.props.navigate(
            `/resident/login`,
        )
    };

    render(): ReactElement {
        return (
            <>
                <NatStepComponent
                    dIspStepInfo={this.state.dIspStepInfo}
                    nowStep={Step.COMPLETE}
                />
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        完了
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                <WideMainContainer>
                    <Box height={'15px'}/>
                    <TextComplete>パスワードの設定が完了しました。</TextComplete>
                    <Box height={'20px'}/>
                </WideMainContainer>
                <Box height={'30px'}/>
                <PrimaryStyledButton onClick={this.linkLoginButtonClick}>
                    ログイン画面に進む
                </PrimaryStyledButton>
                <Box height={'30px'}/>
            </>
        )
    }
}

export default createResidentPage(NatResidentPasswordResetCompletePage)

// 完了
export const TextComplete: StyledP = styled.p`
  text-align: center;
`
